export default __webpack_public_path__ + "d4c4ffb1a148e335b29410d012068dbd.png";